export default __webpack_public_path__ + "static/media/evening-alt.7dd35a79.svg";